var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.694 9.524 20.264-5.672-1.073-2.224C23.183.183 21.47-.414 20.061.305L1.92 9.524h2.774ZM31.017 3.81a2.55 2.55 0 0 0-.733.109l-4.629 1.384-14.136 4.22h23.039l-.866-3.473c-.333-1.354-1.454-2.24-2.675-2.24Z",
    fill: "#24CCA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.45 10.716H2.25a2.249 2.249 0 0 0-2.17 1.645 2.29 2.29 0 0 0-.08.583v24.828A2.238 2.238 0 0 0 2.246 40h33.2c1.239 0 2.245-.998 2.245-2.228v-6.217H24.364c-2.107 0-3.818-1.698-3.818-3.788V22.81c0-1.025.413-1.956 1.082-2.638a3.791 3.791 0 0 1 2.731-1.145h13.332v-6.084a2.231 2.231 0 0 0-2.241-2.228Z",
    fill: "#4A56E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.268 21.158a2.247 2.247 0 0 0-1.514-.584h-13.39c-1.24 0-2.246.998-2.246 2.228v4.961a2.238 2.238 0 0 0 2.246 2.228h13.39c.256 0 .499-.045.728-.12.296-.099.561-.26.786-.464.45-.406.732-.994.732-1.645v-4.96c0-.65-.283-1.239-.732-1.644Zm-10.215 4.568a1.12 1.12 0 0 1-1.123 1.114h-.745c-.62 0-1.123-.5-1.123-1.114v-.74c0-.357.166-.673.431-.873a1.14 1.14 0 0 1 .692-.241H27.93c.62 0 1.123.499 1.123 1.114v.74Z",
    fill: "#4A56E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e913e53fc56950170fc85e9d5c10775.svg";
export { ForwardRef as ReactComponent };